import { Environment } from 'environment.js'
import { useSelector } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { State } from 'Flux/Slice/index.js'
import type { ISamplePool } from 'Model/index.js'
import { samplePool1, samplePool2, samplePool3, samplePool4 } from 'Util/stubs/testSamplePools.stub.ts'

const testDatasets: ISamplePool[] = [samplePool1, samplePool2, samplePool3, samplePool4]

export const getSamplePools = (state: typeof State) =>
  Environment.DEV_SKIP_LOGIN === 'true' && Environment.ENVIRONMENT === 'development' ? testDatasets : state[orderSlice.name].samplePools

export const useGetSamplePoolSelector = () => useSelector(getSamplePools)
